import {ISODetailProductPromag, ISODetailResponse, ISOProductOrderResponse} from './detail-so.interface';
import { IProductNotFulFill } from '@models/spm.model';
import { IInitSalesOrderDetail } from '@models/sales-order.model';

export class DetailSoModel {
  private initDetailSoData!: IInitSalesOrderDetail;
  private detailSoData!: ISODetailResponse;
  private soProductOrderData!: ISOProductOrderResponse;
  private soProductNotFulFillData!: IProductNotFulFill;
  private soDetailProductPromag!: ISODetailProductPromag[];

  constructor() {}

  get InitDetailSoData() { return this.initDetailSoData; }
  set InitDetailSoData(val) { this.initDetailSoData = val; }

  get DetailSoData() { return this.detailSoData; }
  set DetailSoData(val) { this.detailSoData = val; }

  get SoProductOrderData() { return this.soProductOrderData; }
  set SoProductOrderData(val) { this.soProductOrderData = val; }

  get SoProductNotFulFillData() { return this.soProductNotFulFillData; }
  set SoProductNotFulFillData(val) { this.soProductNotFulFillData = val; }

  get SoDetailProductPromag() { return this.soDetailProductPromag; }
  set SoDetailProductPromag(val) { this.soDetailProductPromag = val; }
}
